var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckNotherLights = function SvgCheckNotherLights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "auto",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.604 26.035a2.85 2.85 0 0 1-2.018-.836l-6.1-6.098a1.681 1.681 0 0 1 2.378-2.377l5.74 5.74L26.791 7.277a1.682 1.682 0 0 1 2.377 2.378L13.622 25.199a2.85 2.85 0 0 1-2.018.836Z",
    fill: "url(#check-nother-lights_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-nother-lights_svg__a",
    x1: 16.327,
    y1: 6.785,
    x2: 16.327,
    y2: 26.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C7CE5"
  })))));
};
export default SvgCheckNotherLights;